import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { FormErrorsModule, IconModule } from '@spartacus/storefront';
import { errorHandlers } from '../../../core/src/global-message/http-interceptors/handlers';
import { CustomAppliedCouponsComponent } from './custom-applied-coupons/custom-applied-coupons.component';
import { CustomCartCouponComponent } from './custom-cart-coupon.component';

@NgModule({
  declarations: [
    CustomCartCouponComponent,
    CustomAppliedCouponsComponent
  ],
  exports: [
    CustomCartCouponComponent,
    CustomAppliedCouponsComponent
  ],
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    I18nModule,
    IconModule,
    FormErrorsModule,
  ],
  providers: [
    ...errorHandlers,
    provideConfig({
      cmsComponents: {
        CartApplyCouponComponent: {
          component: CustomCartCouponComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomCartCouponModule { }
